const Constants = {
	SUPPORTED_LANGUAGES : [ "de", "en", "fr" ],

	// pages
	EMBEDDED_PAGE: "EmbeddedPage",
	ERROR_PAGE: "ErrorPage",
	LESSON_PAGE: "LessonPage",
	START_PAGE: "StartPage",
	STATUS_404_PAGE: "Status404Page"
}

export default {
	install(Vue) {
		Vue.prototype.$getConst = (key) => {
			var c = key ? Constants[key] : undefined;
			if (!c)
				throw("Invalid key fed to $getConst, '" + key + "'.");
			return c;
		}
	}
}
